<template>
  <div>
    <el-date-picker v-model="value" value-format="yyyy-MM-dd" :start-placeholder="placeholder+$t('table.begin')" :end-placeholder="$t('table.end')" type="daterange" @input="onChange" />
  </div>
</template>

<script>
export default {
  name: 'DateTimeRangeSelect',
  data () {
    return {
      value: null
    }
  },
  props: {
    placeholder: String
  },
  methods: {
    onChange: function (value) {
      this.value = value
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DateRangeSelect/index.vue